import React from "react";
import { useMenu } from "@cadenza/ui-hooks";
import CSButton from "../buttons/CSButton.jsx";
import { BsCaretDownFill } from "react-icons/bs";

export function MenuRoot({ children, defaultOpen = false, className }) {
  const api = useMenu(defaultOpen);
  return (
    <div
      className={["menu-item", className].filter(Boolean).join(" ")}
      data-menu-root=""
      {...api.rootProps}
    >
      {typeof children === "function" ? children(api) : children}
    </div>
  );
}

export function MenuButton({
  api,
  children,
  className,
  onClick,
  showCaret = true,
  caretClassName = "cs-medium-icon",
  ...rest
}) {
  const handleClick = (e) => {
    api.toggle();
    onClick?.(e);
  };
  return (
    <CSButton
      className={`${className} btn-nowrap`}
      type="button"
      {...api.buttonProps}
      onClick={handleClick}
      {...rest}
    >
      {children}
      {showCaret && (
        <BsCaretDownFill
          className={caretClassName}
          aria-hidden="true"
          style={{ marginInlineStart: 6 }}
        />
      )}
    </CSButton>
  );
}

export function MenuList({
  api,
  className = "",
  children,
  modalOnMobile = false,
  ...rest
}) {
  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(max-width: 768px)").matches;

  React.useEffect(() => {
    if (modalOnMobile && isMobile && api.open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [modalOnMobile, isMobile, api.open]);

  return (
    <>
      <ul
        className={`dropdown ${api.open ? "show" : ""} ${className}`.trim()}
        {...api.listProps}
        {...rest}
      >
        {children}
      </ul>
      {modalOnMobile && isMobile && api.open ? (
        <div className="dropdown-backdrop" onClick={api.close} />
      ) : null}
    </>
  );
}

export function MenuItem({ onSelect, children, className = "", ...rest }) {
  return (
    <li
      className={`menu-item ${className}`}
      role="menuitem"
      tabIndex={0}
      onClick={(e) => onSelect?.(e)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          onSelect?.(e);
        }
      }}
      {...rest}
    >
      {children}
    </li>
  );
}
